import React, { useEffect } from "react";
import { usePageTransition } from "../services/hooks/usePageTransition";

import { useGlobal } from "../services/hooks/useGlobal";
import Quiz from "../components/Quiz";

export default function quiz() {
  const { startTransition, completeTransition } = usePageTransition();

  const { setPageTitle } = useGlobal();

  useEffect(() => {
    setPageTitle({
      pageTitle: `Personalization & Beauty Quiz`,
    });

    return () => {
      setPageTitle({
        pageTitle: null,
      });
    };
  }, []);

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  return <Quiz />;
}
